import { render } from "./AddWorker.vue?vue&type=template&id=343f06ae&scoped=true"
import script from "./AddWorker.vue?vue&type=script&lang=js"
export * from "./AddWorker.vue?vue&type=script&lang=js"

import "./AddWorker.vue?vue&type=style&index=0&id=343f06ae&scoped=true&lang=css"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343f06ae"]])

export default __exports__